<template>
    <div class="layout-article-page">
        <slot name="header">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
              <div class="uk-light uk-container uk-container-small uk-text-center">

                  <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                  <h1 class="uk-margin-small-top">{{page.title}}</h1>

                  <slot name="summary">
                      <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                  </slot>

                  <slot name="subheader"></slot>

                  <div uk-spinner v-if="$apollo.loading"></div>
              </div>
            </div>
        </slot>

        <div class="uk-section uk-background-white uk-section-medium article-list" v-if="articles && articles.length">
            
            <div class="uk-text-center loadmore uk-position-z-index" uk-sticky="position: bottom; end: !.article-list" v-if="hasNextPage">
                <a class="uk-button uk-button-primary" @click.stop="offset+=limit" v-bind:disabled="$apollo.loading">Load more <div uk-spinner v-if="$apollo.loading"></div></a>
            </div>

            <div class="uk-container uk-margin-large-bottom">

                <ArticleCard :article="article" v-for="article in articles" :key="article.urlSegment" :buttonLabel="buttonLabel" />

            </div>
            
        </div>
    </div>
</template>
<script>
import ArticleCard from '../articles/ArticleCard.vue'
import gql from 'graphql-tag'
import _ from 'lodash'

// GraphQL query
const readArticlePageQuery = gql`
    query($offset: Int!, $limit: Int!, $url: String!) {
      readOneArticlePage(filter: { fullPath: { eq: $url }}){
        id
        articles(offset: $offset, limit: $limit) {
            edges {
                node {
                    title
                    summary
                    link
                    source
                    created
                    image {
                        small
                    }
                }
            },
            pageInfo {
                hasNextPage
            }
        }
      }
    }
`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            articles: [],
            offset: 0,
            limit: 20,
            hasNextPage: false
        }
    },
    components: {
        ArticleCard
    },
    computed: {
        buttonLabel() {
            if(this.page && this.page.urlSegment == 'educator-insights') {
                return 'View Blog'
            }
            else {
                return 'Read More'
            }
        }
    },
    apollo: {
        readArticles: {
            query: readArticlePageQuery,
            variables() {
                return {
                    url: this.$route.path,
                    offset: this.offset,
                    limit: this.limit
                }
            },
            update(data) {
                this.hasNextPage = data.readOneArticlePage.articles.pageInfo.hasNextPage
                this.articles = this.articles.concat(_.map(data.readOneArticlePage.articles.edges, "node"))
            }
        }
    }
}
</script>
